import logo from "./logo.svg";
import "./App.css";
// import Article from "./components/Article";
// import Midashi from "./components/Midashi";
// ↓ ここを1行にまとめます。./componentsで./components.index.jsを見に行く
import { Article, Midashi } from "./components";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        {/* 文字列は中括弧囲んでも囲まなくてもOK */}
        <Midashi midashi={"今日の掘り出し物アイテム"} />
        <Article title={"Kiyo4810初のReact"} content={"ここでは私の初のReactの作成"} />
        <Midashi midashi={"イベントのお知らせ"} />
        <Article title={"タイトル１　だから何やねん"} content={"なんとなくデザインのある雛形サイトはできた。だから何やねんというあなたの心無い声は聞こえている"} />
        <Midashi midashi={"伊丹店移転のお知らせ"} />
        <Article title={"タイトル２　大きな一歩"} content={"しかし私にとってはこれは大きな一歩である。JavaScriptを学習後リアクトを習得したいという欲望"} />

        <p>参照　#04 新・日本一わかりやすいReact入門【基礎編】コンポーネントとprops</p>
        <a className="App-link" href="https://www.youtube.com/watch?v=Q-df0QgZuhE" target="_blank" rel="noopener noreferrer">
          youTube
        </a>
      </header>
    </div>
  );
}

export default App;
